import { STORAGE_KEYS } from '@/constants/config';

// Token storage for Monthly web portal.
//
// NOTE: tokens live in localStorage (PLAN_WEB.md §«Безопасность токена»: риск
// XSS принят для Phase 4 MVP; Phase 5 — перейти на httpOnly cookie).
// Wrap in a module so the rest of the code touches a typed API only.

export const tokenStorage = {
  get(): string | null {
    try {
      return localStorage.getItem(STORAGE_KEYS.authToken);
    } catch {
      return null;
    }
  },
  set(token: string): void {
    try {
      localStorage.setItem(STORAGE_KEYS.authToken, token);
    } catch {
      /* ignore */
    }
  },
  clear(): void {
    try {
      localStorage.removeItem(STORAGE_KEYS.authToken);
      localStorage.removeItem(STORAGE_KEYS.authUser);
    } catch {
      /* ignore */
    }
  },
};
